import { createContext, useContext } from 'react';
import { UseCompletableWizardResult } from 'utils/hooks/useCompletableWizard';
import { structuredActivityStepId } from 'domains/structuredActivities/steps';
import { AssignmentFeedback, StructuredActivityAssociatedMaterial } from 'domains/assignments/types';
import { TypeExpressableAcademyHomeworksFields } from 'types/contentful/clinical';

type StructuredActivityContext = {
  structuredActivityContent: TypeExpressableAcademyHomeworksFields;
  associatedMaterial?: StructuredActivityAssociatedMaterial;
  onComplete: (feedbackData: AssignmentFeedback) => void;
  previewMode: boolean;
} & UseCompletableWizardResult;

export const StructuredActivityCtx = createContext({} as StructuredActivityContext);

export const withStructuredActivityContext = (Component: React.FC, matchingStep: structuredActivityStepId) => {
  return (props: Record<string, unknown>) => {
    const { currentStep } = useContext(StructuredActivityCtx);

    if (matchingStep === currentStep) {
      return <Component {...props} />;
    }

    return null;
  };
};
